import { Component, OnInit, ChangeDetectionStrategy, Input, HostBinding } from "@angular/core";
import { AppService } from "@root/app.service";

@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "host-calendar-date-cell",
  templateUrl: "./calendar-date-cell.component.html",
  styleUrls: ["./calendar-date-cell.component.scss"],
})
export class CalendarDateCellComponent implements OnInit {
  @Input() showMonth = false;
  @Input() date;
  get isInternational() {
    return this.app.app.international;
  }
  constructor(private app: AppService) {}

  @HostBinding("class.is-today") get isToday() {
    return this.date && this.date.isCurrentDay;
  }

  @HostBinding("class.is-weekend") get isWeekend() {
    return this.date && (this.date.day === 5 || this.date.day === 6);
  }
  ngOnInit() {}
}
